import type { Router } from "vue-router"

/**
 * Holds the singleton Router instance so non-component code (the auth store, app-init loops) can
 * navigate without a `useRouter()` setup context. Set once by `router/index.ts` after creation.
 */
let instance: Router | null = null

export function setAppRouter(router: Router): void {
  instance = router
}

export function appRouter(): Router {
  if (!instance) throw new Error("router not initialized — is router/index.ts loaded?")
  return instance
}

/** Query param carrying the path to return to after login. */
export const PARAM_RETURN_PATH_FULL = "returnPath"
